var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertSkeleton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 30.6133V21.8867",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9976 37.625C27.6756 37.625 27.4143 37.8863 27.4166 38.2083C27.4166 38.5303 27.6779 38.7917 27.9999 38.7917C28.3219 38.7917 28.5833 38.5303 28.5833 38.2083C28.5833 37.8863 28.3219 37.625 27.9976 37.625",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7343 9.65768L50.6053 40.9337C52.682 44.569 50.057 49.0933 45.871 49.0933H10.129C5.94068 49.0933 3.31568 44.569 5.39468 40.9337L23.2657 9.65768C25.3587 5.99202 30.6413 5.99202 32.7343 9.65768Z",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSkeleton);
export default __webpack_public_path__ + "static/media/alertSkeleton.76a2d07b83f346a409c6748a0838c469.svg";
export { ForwardRef as ReactComponent };